import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useAtom } from 'jotai';
import { isAuthAtom, userRoleAtom } from '../Services/store/atoms';
import axios from 'axios';
import config from '../Config';
import Loading from './Loading';

const NicknameResolver = () => {
  const { nickname } = useParams();
  const history = useHistory();
  const [isAuth] = useAtom(isAuthAtom);
  const [userRole] = useAtom(userRoleAtom);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchUserId = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${config.REACT_APP_BASE_URL}/api/v1/home/resolveNickname`, {
          params: { nickname }
        });
        if (cancelled) return;
        const userId = response.data.user_id;
        const role = userRole || 'guest';
        const dashboards = ['model', 'client', 'admin', 'user', 'assistant'];
        if (dashboards.includes(role)) {
          history.replace(`/${role}/profileModal/${userId}`, {
            background: { pathname: `/${role}/models`, search: '', hash: '', state: null }
          });
        } else {
          history.replace(`/profileModal/${userId}`, {
            background: { pathname: '/', search: '', hash: '', state: null }
          });
        }
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 404) {
          setError('Usuario no encontrado');
        } else {
          setError('Error al cargar el perfil');
        }
        setLoading(false);
      }
    };
    fetchUserId();
    return () => { cancelled = true; };
  }, [nickname, history, isAuth, userRole]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-dvh">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-dvh px-4">
        <div className="text-center max-w-md">
          <h1 className="text-4xl font-semibold text-gray-300 dark:text-gray-600 mb-4">404</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-6">{error}</p>
          <p className="text-gray-500 dark:text-gray-500 mb-8">
            El enlace que has seguido no es válido o el usuario no existe.
          </p>
          <a
            href="/"
            className="inline-block bg-rose-500 text-white px-6 py-3 rounded-full hover:bg-rose-600 transition-colors"
          >
            Volver al inicio
          </a>
        </div>
      </div>
    );
  }

  return null;
};

export default NicknameResolver;
